function runProcessUrlAndSaveUTMCookies(jsCookie, _) {
	if (data.utmInitialized) {
		return;
	}

	data.utmInitialized = true;

	const currentCookieExists = !!jsCookie.get(runUtmCookieKey());
	if (!currentCookieExists) {
		runSetUtmCookieToDirect(jsCookie);
	}

	let hasReferrer = false;

	if (window.document.referrer) {
		const referrerHostname = new URL(document.referrer).hostname;

		if (referrerHostname !== "iterable.com" && referrerHostname !== "activate.iterable.com") {
			hasReferrer = true;
		}
	}

	if (hasReferrer) {
		const searchEngine = runGetReferrerSearchEngineLegible(_);

		jsCookie.set(
			runUtmCookieKey(),
			JSON.stringify({
				UTM_Medium__c: searchEngine ? 'organic' : 'referral',
				UTM_Source__c: (
					runGetReferrerSearchEngineLegible(_) || document.referrer
				),
				UTM_Campaign__c: 'not set',
				UTM_Content__c: 'not set',
				UTM_Term__c: 'not set',
				GCLID__c: 'not set',
				icid: 'not set'
			}),
			{expires: runUtmCookieExpiration()}
		);
	}

	const searchParams = new URLSearchParams(window.location.search);
	const hasUrlUTMs = _.some(
		['utm_medium', 'utm_source', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'icid'],
		key => searchParams.has(key)
	);
	if (hasUrlUTMs) {
		jsCookie.set(
			runUtmCookieKey(),
			JSON.stringify({
				UTM_Medium__c: searchParams.has('utm_medium') ? searchParams.get('utm_medium') : 'not set',
				UTM_Source__c: searchParams.has('utm_source') ? searchParams.get('utm_source') : 'not set',
				UTM_Campaign__c: searchParams.has('utm_campaign') ? searchParams.get('utm_campaign') : 'not set',
				UTM_Content__c: searchParams.has('utm_content') ? searchParams.get('utm_content') : 'not set',
				UTM_Term__c: searchParams.has('utm_term') ? searchParams.get('utm_term') : 'not set',
				GCLID__c: searchParams.has('gclid') ? searchParams.get('gclid') : 'not set',
				icid: searchParams.has('icid') ? searchParams.get('icid') : 'not set'
			}),
			{expires: runUtmCookieExpiration()}
		);
	}

	const firstCookieExists = !!jsCookie.get(runFirstUtmCookieKey());
	if (!firstCookieExists) {
		jsCookie.set(
			runFirstUtmCookieKey(),
			JSON.stringify(_.mapKeys(
				JSON.parse(jsCookie.get(runUtmCookieKey())),
				(value, key) => `First_${key}`
			)),
			{expires: runUtmCookieExpiration()}
		);
	}
}